<template>
  <div class="std-page-title">
    <span class="std-page-title__title">{{ title }}</span>
    <vh-tooltip v-if="!!$props.content || !!$slots.content" v-bind="$props">
      <div slot="content">
        <slot name="content"></slot>
      </div>
      <i class="iconfont-v3 saasicon_help_m"></i>
    </vh-tooltip>
    <slot name="default"></slot>
  </div>
</template>

<script>
  import { Tooltip } from 'vhall-ui';

  export default {
    name: 'StdPageTitle',
    props: {
      title: {
        type: String,
        required: true
      },
      ...Object.assign(Tooltip.props, {
        placement: {
          type: String,
          default: 'right'
        },
        effect: {
          type: String,
          default: 'dark'
        }
      })
    }
  };
</script>

<style lang="less">
  .std-page-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &__title {
      color: #1a1a1a;
      font-size: 22px;
      line-height: 32px;
      font-weight: 600;
      margin-right: 8px;
    }

    .saasicon_help_m {
      font-size: 16px;
    }
  }
</style>
